export const MAIL_GROUPS = {
  registered_users: '84539426112276065',
  pro_users: '84551672754341010',
  previous_pro_users: '84551722338354329'
}